import React from 'react';
import Navbar from '../components/Navbar';
import './Welcome.css';

const Welcome = () => {
    return (
        <div>
            <Navbar />
            <section className="welcome section">
                <div className="message-container">
                    {/* Couple Name and Wedding Date */}
                    <div className="header-content">
                        <h1 className="couple-name">
                            <p>Tim Decilveo</p>
                            <p>&</p>
                            <p>Seneca Negrete</p>
                        </h1>
                        <p className="wedding-date">November 8, 2025</p>
                    </div>

                    <hr className="divider" /> {/* Top Divider */}

                    {/* Welcome Message */}
                    <div className="message">
                        <p>Dear Friends & Family,</p>
                        <p>
                            The road has brought you here, to this place of cobblestones and color, of quiet evenings and joyful gatherings. San Miguel 
                            de Allende holds its arms wide open, and so do we. Casa Adela waits, warm and alive, ready to hold the memories we'll make together.
                        </p>
                        <p>
                            This weekend is not just a celebration of a wedding. It is a celebration of love—the kind that endures, the kind that laughs, 
                            the kind that binds hearts together over time and distance. It is the story of us, Tim and Seneca, but it is also the story of 
                            you, our people, who have carried us here.
                        </p>
                        <p>
                            There is much to see, much to taste, and much to feel. Walk the streets. Let the light find you. Raise a glass. Dance until the 
                            stars blur. Feel the love that surrounds you, in this moment, in this place.
                        </p>
                        <p>
                            You've come far, and for that, we are grateful. Now, be with us. Celebrate. Love.
                        </p>
                        <p>
                            Yours,<br />
                            Tim & Seneca
                        </p>
                    </div>
                    <hr className="divider" /> {/* Bottom Divider */}
                </div>
            </section>
        </div>
    );
};

export default Welcome;
